import Fire_base from '../../Config/Fire_base'

const Logout = async () => {
    await Fire_base.auth().signOut()
        .then(res => {return res})
        .catch(error => {return error})
}

export default Logout